export default __webpack_public_path__ + "static/media/GAMES - 1.9d968c92.png";